const state = {
  list: [],
  chosenList: [],
  isEdit: false,
}

const getters = {
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
  setChosenList (state, chosenList) {
    state.chosenList = chosenList
  },
  setIsEdit (state, isEdit) {
    state.isEdit = isEdit
  },
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/mx-dg/cart/search', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      commit('setList', res.data.list)
    })
  },
  batchAdd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/mx-dg/cart/batch-add', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchDel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/mx-dg/cart/batch-del', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
